import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from'@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import useTrainStationPredictionListItemStyles from './useTrainStationPredictionListItemStyles';

const TrainStationPredictionListItem = (props) => {
    const { 
        stopId, 
        route,
        destination,
        time,
        isDelay
    } = props;
    const classes = useTrainStationPredictionListItemStyles(props);

    const getPredictionText = () => {
        if (isDelay) return 'DELAY';
        return `${time} min`;
    }
    const avatarText = route.charAt(0).toUpperCase();
    return (
        <ListItem button>
            <ListItemAvatar>
                <Avatar className={classes.avatar}>{avatarText}</Avatar>
            </ListItemAvatar>
            <ListItemText primary={destination} secondary={`#${stopId}`}/>
            <ListItemText primary={getPredictionText()}/>
        </ListItem>
    );
}

export default TrainStationPredictionListItem;